const COLORS = {
//  ------------------#colour used for application theme -----------------------
  primary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
  secondary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
  accent: "#e59d02",
  border: "#d6d6d6",
  text: "#000000",
  textSecondary: "red",
  background: "white",
  hoverBg: "rgba(233, 69, 96, 0.1)",
  
 

//btn colours
button : "#37474f",
hover_btn : "#78909c",

// deactivate btn colours
button_red_bg: "#ff1744",
hover_red_btn : "#b71c1c",

// activate btn colours
hover_green_btn: "#4caf50",
button_green_bg: "#76ff03",

// edit btn colours
button_edit_bg: "#00b0ff",
hover_edit_btn:"#0277bd",


};

export default COLORS;
